import { Button } from "@omni/ui/components/Button/button.component";

import { BlockSection } from "@/components/General/BlockSection/blockSection.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { BonusCardStatus } from "@/utils/enums";

const statusTkSuffixMap: Partial<Record<BonusCardStatus, string>> = {
    [BonusCardStatus.Requested]: ".requested",
    [BonusCardStatus.CardOnRoute]: ".onRoute"
};

type RequestBonusCardComponentProps = {
    openModal: () => void;
    bonusCardStatus: BonusCardStatus | null;
};

const RequestBonusCardBlockComponent = ({
    openModal,
    bonusCardStatus
}: RequestBonusCardComponentProps) => {
    const { t } = useGranite();
    const statusTkSuffix =
        bonusCardStatus && statusTkSuffixMap[bonusCardStatus]
            ? statusTkSuffixMap[bonusCardStatus]
            : "";

    const { title, description } = {
        title: t(`blockSection.requestBonusCard.title${statusTkSuffix}`),
        description: t(
            `blockSection.requestBonusCard.description${statusTkSuffix}`
        )
    };

    const enableRequest = bonusCardStatus === BonusCardStatus.NoCard;

    return (
        <BlockSection
            title={title}
            iconClass={"las la-credit-card la-4x"}
        >
            <p>{description}</p>
            {enableRequest && (
                <Button
                    type={"button"}
                    color={"light-gray"}
                    onClick={openModal}
                >
                    {t("account.bonusCard.request.button")}
                </Button>
            )}
        </BlockSection>
    );
};

export { RequestBonusCardBlockComponent };
